import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { LookupModel } from '../../../../api/models';
import { INodeViewModel } from '../../../../core/visual/work-flow-editor/models/i-node-view-model';
import { FlexModule } from '@angular/flex-layout';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSimpleSelectComponent } from '../../../../editors/mat-simple-select/mat-simple-select.component';
import { MatButton } from '@angular/material/button';

export interface EditWorkflowEventDialogData {
  selectOptions: LookupModel[];
  node: INodeViewModel<any>;
}

@Component({
    selector: 'app-edit-workflow-event-dialog-component',
    templateUrl: './edit-workflow-event-dialog-component.component.html',
    styleUrls: ['./edit-workflow-event-dialog-component.component.scss'],
    standalone: true,
    imports: [
        MatDialogTitle,
        FlexModule,
        CdkScrollable,
        MatDialogContent,
        MatSimpleSelectComponent,
        FormsModule,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class EditWorkflowEventDialogComponent implements OnInit {
  public nodeType = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: EditWorkflowEventDialogData,
    private readonly _dialogRef: MatDialogRef<EditWorkflowEventDialogComponent>,
  ) {}

  public ngOnInit(): void {
    this.nodeType = this.data.node?.type;
  }

  public onSave(): void {
    this._dialogRef.close(this.nodeType);
  }
}
